/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function LockOnIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M15 12v4h10v-4c0-2.75-2.25-5-5-5-2.812 0-5 2.25-5 5m-3 4v-4c0-4.375 3.563-8 8-8 4.375 0 8 3.625 8 8v4h2c2.188 0 4 1.813 4 4v12c0 2.25-1.812 4-4 4H10c-2.25 0-4-1.75-4-4V20c0-2.187 1.75-4 4-4zm-3 4v12c0 .563.438 1 1 1h20c.5 0 1-.437 1-1V20c0-.5-.5-1-1-1H10c-.562 0-1 .5-1 1"/>}
        </IconWrapper>);
}
